import React from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import { BlogPopular } from '@sections/Blog-Popular';
import { DownloadFrame } from '@sections/Download-Frame';
import { paddingLevel, Points } from '@styles';
import { BLOG_CATEGORIES } from '@constants';
import { Content } from './Content';

export const BlogArticlePage = ({ content = {}, popular = [] }) => {
  const { query } = useRouter();
  const { category } = query;
  const isUpdatePage = query && category === BLOG_CATEGORIES.UPDATES;

  return (
    <Container>
      <Content content={content} />
      {isUpdatePage && <DownloadFrame />}
      <BlogPopular articles={popular} />
    </Container>
  );
};

const Container = styled.div`
  ${paddingLevel('top', 'blog_page')};
  ${paddingLevel('bottom', 'colar')};
  padding-top: 65px;

  @media ${Points.tablet_portrait} {
    padding-top: 80px;
  }

  @media ${Points.laptop} {
    padding-top: 60px;
  }

  @media ${Points.fullhd} {
    padding-top: 70px;
  }
`;
